import axios from 'axios';

import type { Store } from '@reduxjs/toolkit';
import type { AxiosRequestConfig } from 'axios';
import type { ApiResponse } from './types';

import { clearAuth } from '@/store/slices/authSlice';

const instance = axios.create({
  withCredentials: true,
});

const setupInterceptors = (store: Store): void => {
  instance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response?.status === 401) {
        // error.response is missing if a request is cancelled -> error.message
        // clearAuth(): clearing state.auth.user will
        // automatically redirect to "/" inside <PrivateRoute />
        store.dispatch(clearAuth());
        window.location.href = '/api/v3/auth/login';
      }
      return Promise.reject(error);
    },
  );
};

const get = (url: string, config?: AxiosRequestConfig): ApiResponse => instance.get(`/api/v2${url}`, config);

const remove = (url: string, config?: AxiosRequestConfig): ApiResponse => instance.delete(`/api/v2${url}`, config);

const post = <Response>(url: string, data?: unknown, config?: AxiosRequestConfig): ApiResponse =>
  instance.post<Response>(`/api/v2${url}`, data, config);

const put = <Response>(url: string, data?: unknown, config?: AxiosRequestConfig): ApiResponse =>
  instance.put<Response>(`/api/v2${url}`, data, config);

export { setupInterceptors, get, post, put, remove };
